import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  TerminalDataModel,
  TranslationsLibService,
  Breadcrumb,
  HelpersLibService,
  IrrigationService,
  IrrigationEquipmentModel,
} from '@nutricontrol/app360-shared';
import { RemoteButton } from 'src/app/commons/components/remote-control/remote-control.model';
import { Subscription, interval } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-irrigation-remote-control',
  templateUrl: './irrigation-remote-control.component.html',
  styleUrls: ['./irrigation-remote-control.component.scss'],
})
export class IrrigationRemoteControlComponent implements OnInit, OnDestroy {
  @Input() terminal: TerminalDataModel;
  breadcrumbs: Breadcrumb[] = [];
  public ready = false;
  public equipmentReady = false;
  public buttonQueue: RemoteButton[];
  public lastSendedButton: RemoteButton | null;
  private equipmentSubscription: Subscription;
  private terminal_vid: string;
  private equipment: IrrigationEquipmentModel;

  constructor(
    private router: Router,
    private translationsLib: TranslationsLibService,
    private activatedRoute: ActivatedRoute,
    private helpersLib: HelpersLibService,
    private irrigationService: IrrigationService
  ) {}

  ngOnInit() {
    this.setPageTitle();
    this.getTerminal();
    this.generateBreadcrumbs();
    this.loadEquipment(this.terminal_vid);
    this.equipmentSubscription = interval(
      environment.intervalDefaultTimeout
    ).subscribe(() => {
      this.loadEquipment(this.terminal_vid);
    });
  }

  ngOnDestroy(): void {
    this.equipmentSubscription.unsubscribe();
  }

  public onButtonQueue(queue: RemoteButton[]) {
    this.buttonQueue = queue;
  }

  public onLastSendedButton(lastSendedButton: RemoteButton | null) {
    this.lastSendedButton = lastSendedButton;
  }

  private setPageTitle() {
    this.activatedRoute.paramMap.subscribe((_) => {
      this.helpersLib.setTitle(
        '',
        this.translationsLib.get('remote_control'),
        null
      );
    });
  }

  private getTerminal() {
    if (this.terminal) {
      this.terminal_vid = this.terminal.vid;
      this.ready = true;
      return;
    }
    const [, , terminal_vid] = this.router.url.split('/');
    this.terminal_vid = terminal_vid;
    this.irrigationService.getTerminal(terminal_vid).subscribe((terminal) => {
      this.terminal = terminal;
      this.generateBreadcrumbs();
      this.ready = true;
    });
  }

  private generateBreadcrumbs() {
    if (!this.terminal) {
      return;
    }
    this.breadcrumbs = [];
    if (this.terminal.field) {
      this.breadcrumbs.push({
        text: this.terminal.field.name,
        disabled: false,
        to: ['/field', { vid: this.terminal.field.vid }],
        active: false,
      });
    }
    this.breadcrumbs.push(
      {
        text: this.terminal.name,
        disabled: false,
        to: `/farming/${this.terminal.vid}/irrigation`,
        active: false,
      },
      {
        text: 'Configuración',
        disabled: false,
        to: `/farming/${this.terminal.vid}/irrigation/5`,
        active: false,
      },
      {
        text: this.translationsLib.get('remote_control'),
        disabled: false,
        active: true,
      }
    );
  }

  private loadEquipment(terminalVid: string) {
    this.irrigationService.getIrrigationTerminal(this.terminal_vid).subscribe({
      next: (irrigationEquipment) => {
        this.equipment = irrigationEquipment;
        this.equipmentReady = true;
      },
      error: (error) => {
        console.error('FetchEquipment error:', error);
      },
    });
  }

  public isEquipmentConnected(): boolean {
    return this.equipment?.connected;
  }
}
